import React from "react";

function CopyIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 33.98 36.83">
      <path
        d="M29.36,0H13.95C11.4,0,9.32,2.07,9.32,4.62v18.32c0,2.55,2.07,4.62,4.62,4.62h15.41c2.55,0,4.62-2.07,4.62-4.62V4.62
		C33.98,2.07,31.91,0,29.36,0z M31.98,22.94c0,1.45-1.18,2.62-2.62,2.62H13.95c-1.45,0-2.62-1.18-2.62-2.62V4.62
		C11.32,3.18,12.5,2,13.95,2h15.41c1.45,0,2.62,1.18,2.62,2.62V22.94z"
      />
      <path
        d="M25.26,30.68c-0.55,0-1,0.45-1,1v0.74c0,1.33-1.08,2.41-2.41,2.41H4.41C3.08,34.83,2,33.74,2,32.41V12.5
		c0-1.33,1.08-2.41,2.41-2.41h0.77c0.55,0,1-0.45,1-1s-0.45-1-1-1H4.41C1.98,8.08,0,10.06,0,12.5v19.92c0,2.43,1.98,4.41,4.41,4.41
		h17.43c2.43,0,4.41-1.98,4.41-4.41v-0.74C26.26,31.12,25.81,30.68,25.26,30.68z"
      />
    </svg>
  );
}

export { CopyIcon };
